import React from 'react';
import { observer } from 'src/utils/mobx-react';
import { MarketId } from 'src_common/common/websocket2/id/WebsocketId';
import { RaceMetaAnteSpecial } from 'src/domains/sportsbook/webview/components/raceSummary/templates/RaceMetaAnteSpecial';
import {
    BreadcrumbRow,
    ChevronLeftButton,
    MetaRacePlace,
    RaceMeta,
    SectionHeader,
    SectionHeaderColumn,
    SectionHeaderColumnWrapper,
} from 'src/domains/sportsbook/webview/components/raceSummary/antePost/HeaderMeta.style';
import { DateTime } from 'src_common/utils/time/time';

interface HeaderMetaAntePostPropsType {
    marketId: MarketId;
    closeEvent: () => void;
}

/** @description _Header meta data for **Ante Post** section_ */
export const HeaderMetaAntePost = observer('HeaderMetaAntePost', (props: HeaderMetaAntePostPropsType) => {
    const { marketId, closeEvent } = props;

    const marketModel = marketId.getModel();

    if (marketModel === null) {
        return null;
    }

    const eventModel = marketModel.getEvent();
    if (eventModel === null) {
        return null;
    }

    const competitionName = eventModel.competition2.getModel()?.name ?? null;

    const racePlace = eventModel.name.trim();
    const raceName = (competitionName ?? '').trim();

    const dateTime = DateTime.from(eventModel.timeSettingsStartTime);
    const formattedDate = dateTime?.format('DD MMM YYYY') ?? '';
    const formattedTime = dateTime?.format('HH:mm') ?? '';

    return (
        <SectionHeader>
            <BreadcrumbRow>
                <ChevronLeftButton
                    position='left'
                    onClick={closeEvent}
                />

                <SectionHeaderColumnWrapper>
                    {racePlace !== '' && <MetaRacePlace>{racePlace}</MetaRacePlace>}

                    <SectionHeaderColumn>
                        {raceName !== '' && <RaceMeta>{raceName}</RaceMeta>}
                        {formattedDate !== '' && <RaceMeta>{formattedDate}</RaceMeta>}
                        {formattedTime !== '' && <RaceMeta>{formattedTime}</RaceMeta>}
                    </SectionHeaderColumn>
                </SectionHeaderColumnWrapper>
            </BreadcrumbRow>

            <RaceMetaAnteSpecial marketModel={marketModel} />
        </SectionHeader>
    );
});
